/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { IoMdClose } from 'react-icons/io';

import { formatTime } from '../utils';

const SqueezeHeader = ({ title, duration, isPlaying, setDisplayAlert, setIsPlaying, endSqueeze }) => {
  const [squeezeDuration, setSqueezeDuration] = useState(null);
  const interval = useRef(null);

  const countDown = () => {
    setSqueezeDuration((prev) => {
      if (prev === 0) {
        clearInterval(interval.current);
        return prev;
      }
      const timeLeft = prev - 1;
      return timeLeft;
    });
  };

  useEffect(() => {
    setSqueezeDuration(duration);
  }, []);

  useEffect(() => {
    if (!isPlaying) {
      if (interval.current) clearInterval(interval.current);
      return;
    }
    interval.current = setInterval(countDown, 1000);
    return () => clearInterval(interval.current);
  }, [isPlaying]);

  useEffect(() => {
    if (squeezeDuration === 0) {
      setIsPlaying();
      endSqueeze();
    }
  }, [squeezeDuration]);

  return (
    <header className="squeeze-view__header">
      <IoMdClose className="squeeze-view__header_icon" onClick={setDisplayAlert} />
      <h2 className="squeeze-view__header_title">{title}</h2>
      <span className="squeeze-view__header_title duration">{formatTime(squeezeDuration)}</span>
    </header>
  );
};

SqueezeHeader.propTypes = {
  title: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  isPlaying: PropTypes.bool.isRequired,
  setDisplayAlert: PropTypes.func.isRequired,
  setIsPlaying: PropTypes.func.isRequired,
  endSqueeze: PropTypes.func.isRequired,
};

export default SqueezeHeader;
